/**
 * Avvio asta e tabella: start auction, inizializzazione tabella e rendering filtri ruolo
 * (estratto da FantAPP via mixin sul prototype).
 * Tutte le funzioni usano `this` (l'istanza FantAPP) esattamente come prima.
 */
import { log } from "../utils/logger.js";
import { eventManager, Events } from "../core/events.js";
import { filtersManager, getRoleFilterChipClass } from "../features/filters/index.js";
import { resolveStudioPlayerMantraRoles } from "./studioCalc.js";
import { SessionPersistence } from "../services/SessionPersistence.js";

export const auctionTableMethods = {
  /**
   * Avvia auction
   */
  async startAuction() {
    SessionPersistence.setView('auction', 'main');
    await this.showAuctionView({ restore: false, initialView: 'main' });
    log.info("Auction: Avviata");
  },

  /**
   * Inizializza tabella auction
   */
  initializeAuctionTable() {
    if (this.state.allPlayers.length === 0) {
      log.warn("Auction: Nessun giocatore caricato");
      return;
    }

    // Genera filtri ruolo
    this.renderRoleFilters();


    // Imposta ordinamento predefinito per quotazione
    eventManager.emit(Events.TABLE_SORT, {
      column: "quot",
      direction: "desc",
    });

    // *** FIX: Forza applicazione filtri per popolare la tabella se non ancora fatto ***
    // Questo garantisce che i dati filtrati vengano inviati al TableManager tramite Events.TABLE_UPDATE
    filtersManager.applyFilters();

    log.info("Auction: Tabella inizializzata");
  },

  /**
   * Renderizza filtri ruolo
   */
  renderRoleFilters() {
    const container = document.querySelector(".role-filters");
    if (!container) return;

    const rolesSet = new Set();
    for (const player of this.state.allPlayers) {
      for (const role of resolveStudioPlayerMantraRoles(player)) {
        rolesSet.add(role);
      }
    }

    const roleOrder = [
      "P",
      "DS",
      "DC",
      "DD",
      "B",
      "E",
      "M",
      "C",
      "W",
      "T",
      "A",
      "PC"
    ];

    const sortedRoles = roleOrder.filter((role) => rolesSet.has(role));

    // Genera bottoni
    container.innerHTML = sortedRoles
      .map((role) => {
        const chipClass = getRoleFilterChipClass(role);
        return `<button type="button" class="${chipClass}" data-role="${role}" aria-pressed="false">${role}</button>`;
      })
      .join("");

    if (!container.dataset.filtersBound) {
      container.dataset.filtersBound = "1";
      container.addEventListener("click", (e) => {
        const button = e.target.closest(".role-filter");
        if (!button) return;

        const role = button.dataset.role;
        const currentRoles = filtersManager.getFilter("roles");
        const newRoles = currentRoles.includes(role)
          ? currentRoles.filter((r) => r !== role)
          : [...currentRoles, role];

        filtersManager.setFilter("roles", newRoles);
        this.syncFilterChipStates();
        this.syncFiltersChrome();
      });
    }

    this.syncFilterChipStates();
    this.syncFiltersChrome();
  },
};
